import DangerCircle2 from '@/images/DangerCircle2.svg';
import LoadingAnimation from '@/images/LoadingAnimation.json';
import { useFlag } from '@/services/featureFlags';
import { LibraryItem } from '@d-id/types';
import styled from '@emotion/styled';
import { Player } from '@lottiefiles/react-lottie-player';
import CustomTooltip from '../ToolTip/CustomTooltip';
import { ProjectFailedFriendlyToast } from './constants';
import { getFriendlyToastError } from './utils';

const OverlayContainer = styled.div`
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    color: ${({ theme }) => theme.colors.secondary[900]};
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 16px;
    font-weight: 600;
    letter-spacing: -0.32px;
    height: 50%;
    top: 50%;
    transform: translate(0%, -50%);
    z-index: 5;
`;

const VideoErrorTooltipContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const Loading = styled(Player)<{ isSmall?: boolean }>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: ${({ isSmall }) => (isSmall ? 8 : 16)}rem;
`;

const ErrorImage = styled.img`
    width: 40px;
    height: 40px;
`;

interface Props {
    isDone: boolean;
    isError: boolean;
    item: LibraryItem;
    isLoading: boolean;
}

export const VideoTileOverlay = ({ isDone, isError, item, isLoading }: Props) => {
    const projectFailedErrorToFriendlyToastJson = useFlag<Record<string, ProjectFailedFriendlyToast>>(
        'project_failed_error_to_friendly_toast_json',
        {}
    );

    const internalErrorReason = item?.error?.description || item?.error?.message || item?.error?.kind;

    const { title } = getFriendlyToastError(projectFailedErrorToFriendlyToastJson, internalErrorReason);

    return (
        <>
            {!isDone && (
                <OverlayContainer>
                    {isError && (
                        <CustomTooltip cursor="pointer" placement="top" title={title}>
                            <VideoErrorTooltipContent>
                                <ErrorImage src={DangerCircle2} />
                                Failed to generate video
                            </VideoErrorTooltipContent>
                        </CustomTooltip>
                    )}
                    {isLoading && <Loading src={LoadingAnimation} autoplay loop />}
                </OverlayContainer>
            )}
        </>
    );
};
